import deepEqual from 'lodash/isEqual';

export default deepEqual;
